// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import { SPACE } from 'utils/constants/common';
import { MIN_BUDGET, MIN_RESPONSES, ONE_RESPONSE_PRICE } from 'utils/vrCampaign';

import vrPackageFormFieldTouch from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_form_field_touch';
import { Flex, NumberInput, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    selectVrCampaignBudget,
    selectVrCampaignErrors,
    setVrCampaignBudget,
    setVrCampaignErrors,
    setVrCampaignResponses,
} from 'store/models/vrCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'VrCampaignBuilderPage.budget.title',
    error: 'VrCampaignBuilderPage.budget.error',
    postfix: 'currency.short',
};
export const Budget: FC = () => {
    const trls = useTrls();
    const dispatch = useDispatch();

    const budget = useSelector(selectVrCampaignBudget);
    const hasError = useSelector(selectVrCampaignErrors).budget;

    const validateLinkedFields = (nextResponses: number, nextBudget: number) => {
        dispatch(
            setVrCampaignErrors({
                responses: nextResponses < MIN_RESPONSES,
                budget: nextBudget < MIN_BUDGET,
            })
        );
    };

    const handleBlur = () => {
        const nextResponses = Math.floor(Number(budget) / ONE_RESPONSE_PRICE);
        validateLinkedFields(nextResponses, Number(budget));
        vrPackageFormFieldTouch({ fieldName: 'amount', amount: Number(budget) });
    };

    const handleBudgetChange = (value: string) => {
        const nextBudget = Number(value);
        const nextResponses = Math.floor(nextBudget / ONE_RESPONSE_PRICE);

        validateLinkedFields(nextResponses, nextBudget);
        dispatch([setVrCampaignBudget(nextBudget), setVrCampaignResponses(nextResponses)]);
    };

    return (
        <Flex direction="column" gap={12} grow={1} basis={0}>
            <Text>{trls(TrlKeys.title)}</Text>
            <NumberInput
                errorMessage={hasError ? trls(TrlKeys.error) : null}
                invalid={hasError}
                value={String(budget)}
                onChange={handleBudgetChange}
                onFocus={() => dispatch(setVrCampaignErrors({ responses: false, budget: false }))}
                onBlur={handleBlur}
                groupSeparator={SPACE}
                decimalLength={0}
                allowNegative={false}
                postfix={trls(TrlKeys.postfix)}
                data-qa="vr-campaign-budget-input"
            />
        </Flex>
    );
};
